import AlternativeQuickAnswer from "@/components/sections/alternatives/shared/quick-answer";
import { QUICK_ANSWER, KEY_TAKEAWAYS } from "./data";

export default function SoaxQuickAnswer() {
  return (
    <AlternativeQuickAnswer
      competitorName="SOAX"
      quickAnswer={QUICK_ANSWER}
      takeaways={KEY_TAKEAWAYS}
    />
  );
}
